import { createStore } from 'redux'
import { rootReducer } from './rootReducer'

// https://github.com/zalmoxisus/redux-devtools-extension#12-advanced-store-setup
export const configure = (initialState = {}) => {
  const store = createStore(
    rootReducer,
    initialState
  )

  window.thumbster_redux = store

  if (module.hot) {
    (module).hot.accept(rootReducer, () => {
      // eslint-disable-next-line global-require
      const nextReducer = require('./rootReducer').rootReducer
      store.replaceReducer(nextReducer)
    })
  }
  return store
}
